import { Injectable } from '@angular/core';
import { Comment } from './comment.model';
import { ModelService } from 'ng2-app/modules/shared/services/model.service';
import * as _ from 'lodash';
import { ApiHttpClient } from 'app/http/clients/api';

@Injectable()
export class CommentService extends ModelService<Comment> {
    protected urlPath = '/comment';

    constructor(http: ApiHttpClient) {
        super(http);
    }

    protected createFromResponseData(responseData: any): Comment {
        return new Comment(responseData);
    }
}
